import React, { Component, Fragment } from "react";
import { Assignment } from "../../../models/analytics/Assignment"
import { Submission } from "../../../models/studentAssignmentSearch/Submission";
import moment from "moment";

interface StudentAssignmentStatusPillProps {
    assignment?: Assignment;
    submission?: Submission;
}

interface StudentAssignmentStatusPillState {
    pillColour: string;
    pillText: string;
}

export default class StudentAssignmentStatusPill extends Component<StudentAssignmentStatusPillProps, StudentAssignmentStatusPillState>
{
    constructor(props: StudentAssignmentStatusPillProps) {
        super(props);

        this.state = {
            pillColour: "",
            pillText: ""
        }
    }

    public componentDidMount() {
        this.updateState();
    }

    public componentDidUpdate(prevProps: Readonly<StudentAssignmentStatusPillProps>, prevState: StudentAssignmentStatusPillState)
    {
        if(this.props.assignment !== prevProps.assignment)
        {
            this.updateState();
        }
    }

    private updateState() 
    {
        const dueDateInFuture = moment(this.props.assignment?.dueDateTime).isAfter(moment())
        
        let pillColour = "pill--grey";
        
        switch (this.props.submission?.status) {
            case "submitted":
            case "returned":
                pillColour = "pill--green";
                break;
            case "working":
                pillColour = dueDateInFuture ? "pill--amber" : "pill--red"
                break;
            default:
                pillColour = "pill--grey"
                break;
        }
        
        let pillText = "";
        switch (this.props.submission?.status) {
            case "submitted":
                pillText = "Submitted";
                break;
            case "returned":
                pillText = "Marked";
                break;
            case "working":
                pillText = dueDateInFuture ? "Not Submitted" : "Overdue";
                break;
            default:
                pillText = "Unknown"
                break;
        }
        
        this.setState({
            pillColour,
            pillText
        });
    }
    
    public render(): JSX.Element{
        return (
            <Fragment>
                <div  className={`pill pill--small ${this.state.pillColour}`}> {this.state.pillText}</div>
            </Fragment>
        );
    }
}
